import React from "react";
import { FormattedMessage } from "react-intl";
import { NavLink, useParams } from "react-router-dom";

import { API_PATIENT_OFFERS_LAST_STATIC } from "~/config";
import type { NumericString } from "~/types/common";

import { PageFooterContainer, PageFooterFirstRow, PageFooterSecondRow, PageFooterVersion, PageFooterYear } from "../page_footer";

export function PageFooter() {
  const { patient_id, token } = useParams<{ patient_id: NumericString; token: string }>();

  return (
    <PageFooterContainer center>
      <PageFooterFirstRow>
        <span>
          <PageFooterYear /> <FormattedMessage id="page.footer.header" />
        </span>

        <a href="/" target="_blank" rel="noopener">
          <FormattedMessage id="page.footer.content" />
        </a>
      </PageFooterFirstRow>

      <PageFooterSecondRow>
        <a href="https://3d-smile.ru/policy" target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="Privacy" />
        </a>

        <NavLink to="/contacts">
          <FormattedMessage id="page.footer.contacts" />
        </NavLink>

        {
          <a href={API_PATIENT_OFFERS_LAST_STATIC(patient_id, token)}>
            <FormattedMessage id="page.footer.offer" />
          </a>
        }

        <NavLink to="/payment/details">
          <FormattedMessage id="page.footer.payment" />
        </NavLink>

        <PageFooterVersion />
      </PageFooterSecondRow>
    </PageFooterContainer>
  );
}
